<div class="fast-search" textSmall
     [ngClass]="{'searching': showSearch && searchString,'no-data-found': searchString && searchResults?.person?.length<1 && searchResults?.polizze?.length<1 && searchResults?.schaden?.length<1,
       'hidden':(deviceService.isHandset() && !showSearch),'handset':deviceService.isHandset()}">
  <form [formGroup]="fastSearch" class="search-ele" *ngIf="showSearch">
    <input #searchinput class="search-ele" type="search" [formGroup]="fastSearch" formControlName="search"
           placeholder="Schnellsuche" (keydown)="onKeyDownSearch($event)">
    <div class="search-loader" *ngIf="searching"></div>
  </form>
  <div class="result-list search-ele" *ngIf="searchString && showSearch">
    <div class="result-categories search-ele">
      <div class="category-item search-ele" (click)="setSearchCategory('all')" [ngClass]="{'active':showResultCategory.all,'no-data':searchResults?.person?.length<1 && searchResults?.polizze?.length<1 && searchResults?.schaden?.length<1}">
        <mat-icon class="search-ele">density_small</mat-icon>
        <div class="search-ele">{{(searchResults?.person?.length + searchResults?.polizze?.length  + searchResults?.schaden?.length)}}</div>
      </div>
      <div class="category-item search-ele" (click)="setSearchCategory('person')" [ngClass]="{'active':showResultCategory.person,'no-data':searchResults?.person?.length<1}">
        <mat-icon class="search-ele">person_pin</mat-icon>
        <div class="search-ele">{{searchResults?.person?.length}}</div>
      </div>
      <div class="category-item search-ele" (click)="setSearchCategory('polizze')" [ngClass]="{'active':showResultCategory.polizze,'no-data':searchResults?.polizze?.length<1}">
        <mat-icon class="search-ele">description</mat-icon>
        <div class="search-ele">{{searchResults?.polizze?.length}}</div>
      </div>
      <div class="category-item" (click)="setSearchCategory('schaden')" [ngClass]="{'active':showResultCategory.schaden,'no-data':searchResults?.schaden?.length<1}">
        <mat-icon class="search-ele">quickreply</mat-icon>
        <div class="search-ele">{{searchResults?.schaden?.length}}</div>
      </div>
    </div>
    <div class="result-list-inner search-ele" #innerSearchResultList>
      <ng-container *ngIf="!fastSearchError">
        <ng-container *ngIf="searchResults?.person?.length > 0 && (showResultCategory.person || showResultCategory.all)">
          <div *ngFor="let kunde of searchResults.person;let i = index" class="result-item"
               (click)="openSearchItemPerson(kunde)" [ngClass]="{'current':i==selectedIndex}">
            <div class="result-icon">
              <mat-icon>person_pin</mat-icon>
            </div>
            <div class="result-text">
              <div class="headline">
                {{kunde.person.nachname}} {{kunde.person.vorname}}
              </div>
              <div>
                {{kunde.adresse.plz}} {{kunde.adresse.ortsname}}
              </div>
              <div>
                {{kunde.adresse.strasse}} {{kunde.adresse.hausnr}}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="searchResults?.polizze?.length > 0 && (showResultCategory.polizze || showResultCategory.all)">
          <div *ngFor="let polizze of searchResults.polizze;let i = index;" class="result-item"
               (click)="openSearchItemPolizze(polizze)" [ngClass]="{'current':((i+searchResults?.person?.length)==selectedIndex  && showResultCategory.all) || (showResultCategory.polizze && i === selectedIndex)}">
            <div class="result-icon">
              <mat-icon>description</mat-icon>
            </div>

            <div class="result-text">
              <div class="headline">
                {{polizze.polizzeNr | formatNumber: 'polizze'}}
              </div>
              <div>
                {{polizze.kunde[0].person.nachname}} {{polizze.kunde[0].person.vorname}}
              </div>
            </div>

            <div class="result-info">
              <div>
                {{polizze.ablaufDatum}}
              </div>
              <div>
                {{polizze.praemie | currency: 'EUR':'symbol':'1.2-2':'de'}}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="searchResults?.schaden?.length > 0 && (showResultCategory.schaden || showResultCategory.all)">
          <div *ngFor="let schaden of searchResults.schaden;let i = index;" class="result-item"
               (click)="openSearchItemSchaden(schaden)" [ngClass]="{'current':((i+searchResults?.person?.length+searchResults?.polizze?.length)==selectedIndex && showResultCategory.all) || (showResultCategory.schaden && i === selectedIndex)}">
            <div class="result-icon">
              <mat-icon>quickreply</mat-icon>
            </div>

            <div class="result-text">
              <div class="headline">
                {{schaden.schadenNr | formatNumber: 'schaden'}}
              </div>
              <div>
                {{schaden.kunde.person.nachname}} {{schaden.kunde.person.vorname}}
              </div>
            </div>

            <div class="result-info">
              <div>
                {{schaden.status}}
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container
          *ngIf="searchResults?.person?.length<1 && searchResults?.polizze?.length<1 && searchResults?.schaden?.length<1">
          <div class="no-data-found search-ele">Für den Suchbegriff {{searchString}} gibt es keine Treffer!</div>
        </ng-container>
      </ng-container>
    </div>
    <ng-container
      *ngIf="fastSearchError">
      <div class="no-data-found search-ele">{{fastSearchError}}</div>
    </ng-container>
  </div>

  <div class="search-overlay" *ngIf="showSearch && (searchString || deviceService.isHandset())"
       (click)="closeSearch()"></div>
</div>
